<div class="main-container">
	<div class="__form-container">
		<img class="__logo" src="assets/images/logo.jpg" alt="Logo" />
		<p class="text-muted-dark" *ngIf="!errorMessage">
			Por favor, ingrese las credenciales para acceder al sistema.
		</p>
		<p class="text-danger" *ngIf="errorMessage">
			{{ errorMessage }}
		</p>
		<form class="__form" [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="__field-wrapper">
				<mat-form-field class="__field" appearance="standard">
					<mat-label>Correo Electrónico</mat-label>
					<input
						formControlName="email"
						matInput
						type="email"
						placeholder="Ingrese su correo"
						autocomplete='email'
						name="email"
					/>
					<mat-error
						*ngIf="emailField?.touched && emailField?.hasError('required')"
					>
						El correo electronico es requerido
					</mat-error>
				</mat-form-field>
			</div>
			<div class="__field-wrapper">
				<mat-form-field class="__field" appearance="standard">
					<mat-label>Contraseña</mat-label>
					<div class="__input-wrapper">
						<input
							formControlName="password"
							name="password"
							matInput
							[type]="showPassword ? 'text' : 'password'"
							placeholder="Ingrese su contraseña"
							name="password"
						/>
						<div class="__icons" (click)="togglePassword($event)">
							<mat-icon
								class="__eye"
								[ngClass]="{ '--show': showPassword }"
								>visibility</mat-icon
							>
							<mat-icon
								class="__eye"
								[ngClass]="{ '--show': !showPassword }"
							>
								visibility_off
							</mat-icon>
						</div>
					</div>
					<mat-error
						*ngIf="
							passwordField?.touched && passwordField?.hasError('required')
						"
					>
						La contraseña es requerida
					</mat-error>
				</mat-form-field>
			</div>
			<div class="__reset-password-wrapper">
				<a class="__reset-password" routerLink="/auth/reset-password">
					<mat-icon class="__icon">lock</mat-icon>
					Olvidé mi contraseña
				</a>
			</div>
			<button
				mat-raised-button
				class="__button"
				color="primary"
				[disabled]="form.invalid || loading"
			>
				{{ loading ? 'Cargando' : 'Ingresar' }}
				<mat-icon class="mr1">login</mat-icon>
			</button>
		</form>
		<app-request-support-button></app-request-support-button>
	</div>
	<div class="__image-container">
		<img
			class="__image"
			src="assets/images/background_login.png"
			alt="Login Background"
		/>
	</div>
</div>
